import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=017affef&scoped=true&"
var script = {}
import style0 from "./Notifications.vue?vue&type=style&index=0&id=017affef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017affef",
  null
  
)

export default component.exports